<ng-carpentry-carpentry-configuration
  *ngIf="step === 1 && !isLoading"
  [quotationRecordId]="selectedQuotationRecordId"
  (onComplete)="nextStep($event)"
  (resetQuotationRecordId)="resetQuotationRecordId()">
</ng-carpentry-carpentry-configuration>

<ng-carpentry-accessories *ngIf="step === 2" [quotationRecordId]="selectedQuotationRecordId">
</ng-carpentry-accessories>

<ng-carpentry-summary
  *ngIf="step === 3"
  [refresh]="refresh"
  [selectedAssistances]="configuration.assistances"
  (previous)="previousStep($event)"
  (refreshFinished)="refreshFinishedSet()">
</ng-carpentry-summary>
